import React from "react";
import { GenericPaymentForm } from "./GenericPaymentForm";
// let monerisCheckout = require("https://gatewayt.moneris.com/chkt/js/chkt_v1.00.js");
// myCheckout.setMode("qa");
// myCheckout.setCheckoutDiv("monerisCheckout");

// myCheckout.setCallback("page_loaded", () => console.log("page_loaded"));
// myCheckout.setCallback("cancel_transaction", () =>
//   console.log("cancel_transaction")
// );
// myCheckout.setCallback("error_event", () => console.log("error_event"));
// myCheckout.setCallback("payment_receipt", () => console.log("payment_receipt"));
// myCheckout.setCallback("payment_complete", () =>
//   console.log("payment_complete")
// );

export const MonerisPaymentBox = (props) => {
  const { order, paymentProvider } = props;
  return <GenericPaymentForm order={order} paymentProvider={paymentProvider} />;
};
